import CoreAPIService from '../CoreAPIService';

class CyberMemorialService {
    apiService;

    constructor() {
        this.apiService = new CoreAPIService();
    }

    async searchGoins(searchParams) {
        // Handle both old format (string) and new format (object)
        if (typeof searchParams === 'string') {
            // Legacy support - if string is passed, use it as deceasedName
            return this.apiService.get(`/goins/search?deceasedName=${searchParams}`);
        }
        
        // New format - object with deceasedName or contractorName
        const queryParams = new URLSearchParams();
        if (searchParams.deceasedName) {
            queryParams.append('deceasedName', searchParams.deceasedName);
        }
        if (searchParams.contractorName) {
            queryParams.append('contractorName', searchParams.contractorName);
        }
        
        return this.apiService.get(`/goins/search?${queryParams.toString()}`);
    }

    async loadAllGoins() {
        return this.apiService.get(`/goins/all`);
    } 

    async getGoinProfileImage(goinId) {
        return this.apiService.get(`/cherish/${goinId}`);
    }

    async getLayflowersByGoinId(goinId, page = 1, size = 10) {
        return this.apiService.get(`/cherish/layflowers/goin/${goinId}?page=${page}&size=${size}`);
    }

    async getFlowers(page = 1, size = 10) {
        return this.apiService.get(`/cherish/flowers?page=${page}&size=${size}`);
    }

    async createCherishOfferMessage(data) {
        return this.apiService.post('/cherish/offer', data);
    }
  
    async getMemorialAlbumList(goinId, page = 1, size = 10) {
        return this.apiService.get(`/cherish/cherish-album/goin/${goinId}?page=${page}&size=${size}`);
    }
    async getMemorialAlbumDetail(albumId) {
        return this.apiService.get(`/cherish/cherish-album/${albumId}`);
    }
    async createMemorialAlbumEntry(data) {
        return this.apiService.post('/cherish/cherish-album/create', data);
    }

    async updateMemorialAlbum(data) {
        return this.apiService.put(`/cherish/cherish-album/update`, data);
    }

    async deleteMemorialAlbumById(id) {
        return this.apiService.delete(`/cherish/cherish-album/delete/${id}`);
    }

    async updateGoinProfileImage(goinId, goinName, data) {
       
        const url = `/cherish/profile-image/update?goinId=${goinId}&goinName=${encodeURIComponent(goinName)}`;
   
            const response = await this.apiService.post(url, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });   
            return response.data;
    }
 
    async verifyContractorAuthentication(data) {
        return this.apiService.post('/goins/verify', data);
    }


}

export default new CyberMemorialService();